/* eslint no-console:0 */

// dynamically set __webpack_public_path__ for chunk imports
// https://github.com/webpack/webpack/issues/7968#issuecomment-421058484
if(document.currentScript) {
  const scriptUrl = new URL(document.currentScript.src);
  __webpack_public_path__ = scriptUrl.href.substring(0, scriptUrl.href.indexOf(__webpack_public_path__) + __webpack_public_path__.length);
}

// IE11
import '@stimulus/polyfills';

import 'script-loader!jquery';
import 'script-loader!magnific-popup';
import 'script-loader!../vendor/svg.min.js';
import 'script-loader!../vendor/svg.filter.min.js';

import 'script-loader!bootstrap-4/dist/js/bootstrap.bundle.js';

import '../src/application.scss';

import '../src/browser_update';

import {} from 'jquery-ujs'

import '../src/error_tracking';
import '../src/auth';
import '../src/vue_mount';
import '../src/track';
import '../src/upload';
import '../src/images';
import '../src/pricing';
import '../src/docs';
import '../src/tooltips';
import '../src/api';
import '../src/cookies';
import '../src/sample_images';
import '../src/before_after';
import '../src/hiring';
import '../src/mobile_app';
import '../src/editor/editor';
import '../src/cancellation';

import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"

const application = Application.start()
const context = require.context("../controllers", true, /\.js$/)
application.load(definitionsFromContext(context))
